var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "vue__time-picker time-picker", style: _vm.inputWidthStyle },
    [
      _c("input", {
        ref: "input",
        staticClass: "display-time",
        class: [
          _vm.inputClass,
          {
            "is-empty": _vm.inputIsEmpty,
            invalid: _vm.hasInvalidInput,
            "all-selected": _vm.allValueSelected,
            disabled: _vm.disabled,
            "has-custom-icon": _vm.$slots && _vm.$slots.icon,
          },
        ],
        style: _vm.inputWidthStyle,
        attrs: {
          type: "text",
          id: _vm.id,
          name: _vm.name,
          placeholder: _vm.placeholder ? _vm.placeholder : _vm.formatString,
          tabindex: _vm.disabled ? -1 : _vm.tabindex,
          disabled: _vm.disabled,
          readonly: !_vm.manualInput,
          autocomplete: _vm.autocomplete,
        },
        domProps: { value: _vm.inputIsEmpty ? null : _vm.customDisplayTime },
        on: {
          focus: _vm.onFocus,
          change: _vm.onChange,
          blur: function ($event) {
            _vm.debounceBlur()
            _vm.blurEvent()
          },
          mousedown: _vm.onMouseDown,
          keydown: [
            _vm.keyDownHandler,
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              )
                return null
              return _vm.escBlur.apply(null, arguments)
            },
          ],
          compositionstart: _vm.onCompostionStart,
          compositionend: _vm.onCompostionEnd,
          paste: _vm.pasteHandler,
        },
      }),
      _vm._v(" "),
      _vm.showClearBtn || _vm.showDropdownBtn
        ? _c("div", { staticClass: "controls", attrs: { tabindex: "-1" } }, [
            !_vm.isActive && _vm.showClearBtn
              ? _c(
                  "span",
                  {
                    staticClass: "clear-btn",
                    class: {
                      "has-custom-btn": _vm.$slots && _vm.$slots.clearButton,
                    },
                    attrs: { tabindex: "-1" },
                    on: { click: _vm.clearTime },
                  },
                  [
                    _vm._t("clearButton", function () {
                      return [
                        _c("span", { staticClass: "char" }, [_vm._v("×")]),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showDropdownBtn
              ? _c(
                  "span",
                  {
                    staticClass: "dropdown-btn",
                    class: {
                      "has-custom-btn": _vm.$slots && _vm.$slots.dropdownButton,
                    },
                    attrs: { tabindex: "-1" },
                    on: {
                      click: function ($event) {
                        return _vm.setDropdownState(
                          _vm.fixedDropdownButton ? !_vm.showDropdown : true,
                          true
                        )
                      },
                      mousedown: _vm.keepFocusing,
                    },
                  },
                  [
                    _vm._t("dropdownButton", function () {
                      return [
                        _c("span", { staticClass: "char" }, [_vm._v("▾")]),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots && _vm.$slots.icon
        ? _c("div", { staticClass: "custom-icon" }, [_vm._t("icon")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.showDropdown
        ? _c("div", {
            staticClass: "time-picker-overlay",
            attrs: { tabindex: "-1" },
            on: { click: _vm.toggleActive },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDropdown,
              expression: "showDropdown",
            },
          ],
          ref: "dropdown",
          staticClass: "dropdown",
          class: [_vm.dropdownDirClass],
          style: _vm.inputWidthStyle,
          attrs: { tabindex: "-1" },
          on: {
            mouseup: _vm.keepFocusing,
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "select-list",
              style: _vm.inputWidthStyle,
              attrs: { tabindex: "-1" },
            },
            [
              !_vm.advancedKeyboard
                ? [
                    _vm._l(_vm.columnsSequence, function (column) {
                      return [
                        column === "hour"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "hours",
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  domProps: {
                                    textContent: _vm._s(_vm.hourLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.hours, function (hr, hIndex) {
                                  return [
                                    !_vm.opts.hideDisabledHours ||
                                    (_vm.opts.hideDisabledHours &&
                                      !_vm.isDisabled("hour", hr))
                                      ? _c("li", {
                                          key: hIndex,
                                          class: { active: _vm.hour === hr },
                                          attrs: {
                                            disabled: _vm.isDisabled(
                                              "hour",
                                              hr
                                            ),
                                            "data-key": hr,
                                          },
                                          domProps: { textContent: _vm._s(hr) },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("hour", hr)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        column === "minute"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "minutes",
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  domProps: {
                                    textContent: _vm._s(_vm.minuteLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.minutes, function (m, mIndex) {
                                  return [
                                    !_vm.opts.hideDisabledMinutes ||
                                    (_vm.opts.hideDisabledMinutes &&
                                      !_vm.isDisabled("minute", m))
                                      ? _c("li", {
                                          key: mIndex,
                                          class: { active: _vm.minute === m },
                                          attrs: {
                                            disabled: _vm.isDisabled(
                                              "minute",
                                              m
                                            ),
                                            "data-key": m,
                                          },
                                          domProps: { textContent: _vm._s(m) },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("minute", m)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        column === "second"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "seconds",
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  domProps: {
                                    textContent: _vm._s(_vm.secondLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.seconds, function (s, sIndex) {
                                  return [
                                    !_vm.opts.hideDisabledSeconds ||
                                    (_vm.opts.hideDisabledSeconds &&
                                      !_vm.isDisabled("second", s))
                                      ? _c("li", {
                                          key: sIndex,
                                          class: { active: _vm.second === s },
                                          attrs: {
                                            disabled: _vm.isDisabled(
                                              "second",
                                              s
                                            ),
                                            "data-key": s,
                                          },
                                          domProps: { textContent: _vm._s(s) },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("second", s)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        column === "apm"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "apms",
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  domProps: {
                                    textContent: _vm._s(_vm.apmLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.apms, function (a, aIndex) {
                                  return [
                                    !_vm.opts.hideDisabledHours ||
                                    (_vm.opts.hideDisabledHours &&
                                      !_vm.isDisabled("apm", a))
                                      ? _c("li", {
                                          key: aIndex,
                                          class: { active: _vm.apm === a },
                                          attrs: {
                                            disabled: _vm.isDisabled("apm", a),
                                            "data-key": a,
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.apmDisplayText(a)
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("apm", a)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.advancedKeyboard
                ? [
                    _vm._l(_vm.columnsSequence, function (column) {
                      return [
                        column === "hour"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "hours",
                                attrs: { tabindex: "-1" },
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  attrs: { tabindex: "-1" },
                                  domProps: {
                                    textContent: _vm._s(_vm.hourLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.hours, function (hr, hIndex) {
                                  return [
                                    !_vm.opts.hideDisabledHours ||
                                    (_vm.opts.hideDisabledHours &&
                                      !_vm.isDisabled("hour", hr))
                                      ? _c("li", {
                                          key: hIndex,
                                          class: { active: _vm.hour === hr },
                                          attrs: {
                                            tabindex: _vm.isDisabled("hour", hr)
                                              ? -1
                                              : _vm.tabindex,
                                            "data-key": hr,
                                            disabled: _vm.isDisabled(
                                              "hour",
                                              hr
                                            ),
                                          },
                                          domProps: { textContent: _vm._s(hr) },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("hour", hr)
                                            },
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "tab",
                                                    9,
                                                    $event.key,
                                                    "Tab"
                                                  )
                                                )
                                                  return null
                                                return _vm.onTab(
                                                  "hour",
                                                  hr,
                                                  $event
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "space",
                                                    32,
                                                    $event.key,
                                                    [" ", "Spacebar"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("hour", hr)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("hour", hr)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "up",
                                                    38,
                                                    $event.key,
                                                    ["Up", "ArrowUp"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.prevItem("hour", hr)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "down",
                                                    40,
                                                    $event.key,
                                                    ["Down", "ArrowDown"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.nextItem("hour", hr)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "left",
                                                    37,
                                                    $event.key,
                                                    ["Left", "ArrowLeft"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 0
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toLeftColumn("hour")
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "right",
                                                    39,
                                                    $event.key,
                                                    ["Right", "ArrowRight"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 2
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toRightColumn("hour")
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  $event.ctrlKey ||
                                                  $event.shiftKey ||
                                                  $event.altKey ||
                                                  $event.metaKey
                                                )
                                                  return null
                                                return _vm.debounceBlur.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            ],
                                            blur: _vm.debounceBlur,
                                            focus: _vm.keepFocusing,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        column === "minute"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "minutes",
                                attrs: { tabindex: "-1" },
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  attrs: { tabindex: "-1" },
                                  domProps: {
                                    textContent: _vm._s(_vm.minuteLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.minutes, function (m, mIndex) {
                                  return [
                                    !_vm.opts.hideDisabledMinutes ||
                                    (_vm.opts.hideDisabledMinutes &&
                                      !_vm.isDisabled("minute", m))
                                      ? _c("li", {
                                          key: mIndex,
                                          class: { active: _vm.minute === m },
                                          attrs: {
                                            tabindex: _vm.isDisabled(
                                              "minute",
                                              m
                                            )
                                              ? -1
                                              : _vm.tabindex,
                                            "data-key": m,
                                            disabled: _vm.isDisabled(
                                              "minute",
                                              m
                                            ),
                                          },
                                          domProps: { textContent: _vm._s(m) },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("minute", m)
                                            },
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "tab",
                                                    9,
                                                    $event.key,
                                                    "Tab"
                                                  )
                                                )
                                                  return null
                                                return _vm.onTab(
                                                  "minute",
                                                  m,
                                                  $event
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "space",
                                                    32,
                                                    $event.key,
                                                    [" ", "Spacebar"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("minute", m)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("minute", m)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "up",
                                                    38,
                                                    $event.key,
                                                    ["Up", "ArrowUp"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.prevItem("minute", m)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "down",
                                                    40,
                                                    $event.key,
                                                    ["Down", "ArrowDown"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.nextItem("minute", m)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "left",
                                                    37,
                                                    $event.key,
                                                    ["Left", "ArrowLeft"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 0
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toLeftColumn(
                                                  "minute"
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "right",
                                                    39,
                                                    $event.key,
                                                    ["Right", "ArrowRight"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 2
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toRightColumn(
                                                  "minute"
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  $event.ctrlKey ||
                                                  $event.shiftKey ||
                                                  $event.altKey ||
                                                  $event.metaKey
                                                )
                                                  return null
                                                return _vm.debounceBlur.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            ],
                                            blur: _vm.debounceBlur,
                                            focus: _vm.keepFocusing,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        column === "second"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "seconds",
                                attrs: { tabindex: "-1" },
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  attrs: { tabindex: "-1" },
                                  domProps: {
                                    textContent: _vm._s(_vm.secondLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.seconds, function (s, sIndex) {
                                  return [
                                    !_vm.opts.hideDisabledSeconds ||
                                    (_vm.opts.hideDisabledSeconds &&
                                      !_vm.isDisabled("second", s))
                                      ? _c("li", {
                                          key: sIndex,
                                          class: { active: _vm.second === s },
                                          attrs: {
                                            tabindex: _vm.isDisabled(
                                              "second",
                                              s
                                            )
                                              ? -1
                                              : _vm.tabindex,
                                            "data-key": s,
                                            disabled: _vm.isDisabled(
                                              "second",
                                              s
                                            ),
                                          },
                                          domProps: { textContent: _vm._s(s) },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("second", s)
                                            },
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "tab",
                                                    9,
                                                    $event.key,
                                                    "Tab"
                                                  )
                                                )
                                                  return null
                                                return _vm.onTab(
                                                  "second",
                                                  s,
                                                  $event
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "space",
                                                    32,
                                                    $event.key,
                                                    [" ", "Spacebar"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("second", s)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("second", s)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "up",
                                                    38,
                                                    $event.key,
                                                    ["Up", "ArrowUp"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.prevItem("second", s)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "down",
                                                    40,
                                                    $event.key,
                                                    ["Down", "ArrowDown"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.nextItem("second", s)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "left",
                                                    37,
                                                    $event.key,
                                                    ["Left", "ArrowLeft"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 0
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toLeftColumn(
                                                  "second"
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "right",
                                                    39,
                                                    $event.key,
                                                    ["Right", "ArrowRight"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 2
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toRightColumn(
                                                  "second"
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  $event.ctrlKey ||
                                                  $event.shiftKey ||
                                                  $event.altKey ||
                                                  $event.metaKey
                                                )
                                                  return null
                                                return _vm.debounceBlur.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            ],
                                            blur: _vm.debounceBlur,
                                            focus: _vm.keepFocusing,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        column === "apm"
                          ? _c(
                              "ul",
                              {
                                key: column,
                                staticClass: "apms",
                                attrs: { tabindex: "-1" },
                                on: { scroll: _vm.keepFocusing },
                              },
                              [
                                _c("li", {
                                  staticClass: "hint",
                                  attrs: { tabindex: "-1" },
                                  domProps: {
                                    textContent: _vm._s(_vm.apmLabelText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.apms, function (a, aIndex) {
                                  return [
                                    !_vm.opts.hideDisabledHours ||
                                    (_vm.opts.hideDisabledHours &&
                                      !_vm.isDisabled("apm", a))
                                      ? _c("li", {
                                          key: aIndex,
                                          class: { active: _vm.apm === a },
                                          attrs: {
                                            tabindex: _vm.isDisabled("apm", a)
                                              ? -1
                                              : _vm.tabindex,
                                            "data-key": a,
                                            disabled: _vm.isDisabled("apm", a),
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.apmDisplayText(a)
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.select("apm", a)
                                            },
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "tab",
                                                    9,
                                                    $event.key,
                                                    "Tab"
                                                  )
                                                )
                                                  return null
                                                return _vm.onTab(
                                                  "apm",
                                                  a,
                                                  $event
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "space",
                                                    32,
                                                    $event.key,
                                                    [" ", "Spacebar"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("apm", a)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.select("apm", a)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "up",
                                                    38,
                                                    $event.key,
                                                    ["Up", "ArrowUp"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.prevItem("apm", a)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "down",
                                                    40,
                                                    $event.key,
                                                    ["Down", "ArrowDown"]
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.nextItem("apm", a)
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "left",
                                                    37,
                                                    $event.key,
                                                    ["Left", "ArrowLeft"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 0
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toLeftColumn("apm")
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "right",
                                                    39,
                                                    $event.key,
                                                    ["Right", "ArrowRight"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 2
                                                )
                                                  return null
                                                $event.preventDefault()
                                                return _vm.toRightColumn("apm")
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                )
                                                  return null
                                                if (
                                                  $event.ctrlKey ||
                                                  $event.shiftKey ||
                                                  $event.altKey ||
                                                  $event.metaKey
                                                )
                                                  return null
                                                return _vm.debounceBlur.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            ],
                                            blur: _vm.debounceBlur,
                                            focus: _vm.keepFocusing,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }